// src/components/CartIcon.js
import {React ,useMemo}from "react";
import { useNavigate } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { useCart } from "../../context/cartContext";
import { useSite } from "../../context/siteContext"; // Add this import
import { ROUTES } from "../../constants";
import { Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

function CartIcon() {
    const { cartItems } = useCart(); 
    const { selectedSite } = useSite();
    const navigate = useNavigate();
    const { t } = useTranslation();

    // Use the working manual calculation
    const actualCount = useMemo(() => {
        const filteredItems = cartItems?.filter(item => item.Site === selectedSite) || [];
        return filteredItems.reduce((sum, item) => sum + (parseInt(item.Quantity) || 0), 0);
    }, [cartItems, selectedSite]);

    const handleClick = () => {
        navigate(ROUTES.CART);
    };

    // Show correct count with 99+ limit
    const displayCount = actualCount >= 99 ? "99+" : actualCount;

    return (
        <Tooltip title={t("UI_TEXT.TOOLTIP_CART")} arrow placement="bottom">
            <Badge
                    badgeContent={displayCount}
                    color="primary"
                showZero={true}
                sx={{ '& .MuiBadge-badge': { right: 10, top: 2, fontSize: '11px' } }}
                >
                <IconButton color="primary" onClick={handleClick} sx={{ mr: 1 }}>
                    <ShoppingCartOutlinedIcon />
                </IconButton>

            </Badge>

        </Tooltip>
    );
}

export default CartIcon;
